import React, { Component } from "react";
import { UncontrolledAlert, Button } from "reactstrap";
import { withFormsy } from "formsy-react";
import { mealPlanService } from "./services/mealPlan.services";
import { MySelect } from "../../Shared/Forms";
import { Spinner } from "../../Shared";

class FoodLibraryDropDown extends Component {
    state = {
        fetching: false,
        fetched: false,
        response: null,
        error: null,
    };

    componentDidMount() {
        this.getFoodItems({ "page-num": 1, "page-size": 100 });
    }

    getFoodItems = async (params) => {
        this.setState({
            ...this.state,
            fetching: true,
        });
        try {
            let response = await mealPlanService.getFoodItems(params);
            if (response) {
                
                let mealData = response.data.map((value) => {
                    return value;
                });
                this.setState({
                    ...this.state,
                    fetching: false,
                    fetched: true,
                    response: mealData,
                    error: null,
                });
            }
        } catch (error) {
            this.setState({
                ...this.state,
                fetching: false,
                fetched: false,
                error,
            });
        }
    };

    render() {
        const { name, value, disabled, isMulti, title, isRequired, isClearable, onChange, day, mealTypeCode, addFoodItemToArry, mealModulus,isRoaster,index} = this.props;

        const { fetching, response, error } = this.state;

        return (
            <div>
                {fetching ? (
                    <UncontrolledAlert color="info">
                        <Spinner message="Fetching food items" />
                    </UncontrolledAlert>
                ) : (
                    <div>
                        <MySelect
                            isMulti={isMulti}
                            name={name}
                            isClearable={isClearable}
                            title={title}
                            options={response ? response : []}
                            value={value}
                            valueKey="id"
                            disabled={disabled}
                            labelKey="name"
                            innerRef={(c) => {
                                this.metrics = c;
                            }}
                            required={isRequired}
                            onChange={onChange}
                            day={day}
                            mealTypeCode={mealTypeCode}
                            mealModulus={mealModulus}
                            addFoodItemToArry={addFoodItemToArry}
                            isRoaster={isRoaster}
                            index={index}
                        />
                        {!response && error && (
                            <UncontrolledAlert color="danger">
                                {error.message}
                                <div className="text-reight">
                                    <Button color="danger" onClick={this.getFoodItems}>
                                        Retry
                                    </Button>
                                </div>
                            </UncontrolledAlert>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default withFormsy(FoodLibraryDropDown);
